import { concatenateStyle } from '../utils';
import type { EditorPlugin } from '../../../types/aha-editor';

const FontSizeMarkPlugin: EditorPlugin = {
  name: 'Font size mark plugin',
  mark: {
    type: 'fontSize',
    use: ({ leaf, props }) =>
      concatenateStyle({ ...props }, 'fontSize', leaf.fontSize),
  },
};
export default FontSizeMarkPlugin;
